import React, { Suspense } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import Hero from './components/Hero';
import ParticlesBackground from './components/ParticlesBackground';
import BackgroundElements from './components/BackgroundElements';

// Lazy load components that are not immediately visible
const About = React.lazy(() => import('./components/About'));
const Services = React.lazy(() => import('./components/Services'));
const Contact = React.lazy(() => import('./components/Contact'));
const Footer = React.lazy(() => import('./components/Footer'));

function App() {
  return (
    <AppContainer>
      <ParticlesBackground />
      <BackgroundElements />
      <GradientOverlay />
      <BackgroundShapes>
        <Shape1 className="floating-slow" />
        <Shape2 className="floating-medium" />
        <Shape3 className="floating-fast" />
      </BackgroundShapes>
      <ContentWrapper>
        <Hero />
        <Suspense fallback={<div style={{ height: '100vh' }} />}>
          <About />
          <Services />
          <Footer />
        </Suspense>
      </ContentWrapper>
    </AppContainer>
  );
}

const AppContainer = styled.div`
  position: relative;
  min-height: 100vh;
  background: #0a0a0a;
  overflow: hidden;
  direction: rtl;
`;

const GradientOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(800px circle at 80% 20%, rgba(38, 208, 206, 0.15), transparent 40%),
    radial-gradient(600px circle at 20% 40%, rgba(26, 41, 128, 0.1), transparent 40%),
    radial-gradient(700px circle at 60% 70%, rgba(38, 208, 206, 0.1), transparent 40%);
  filter: blur(10px);
  pointer-events: none;
  z-index: 1;
  will-change: transform;
  transform: translateZ(0);
`;

const BackgroundShapes = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
`;

const Shape = styled.div`
  position: absolute;
  border-radius: 50%;
  background: rgba(38, 208, 206, 0.05);
  filter: blur(20px);
`;

const Shape1 = styled(Shape)`
  width: 400px;
  height: 400px;
  top: 10%;
  right: 15%;
`;

const Shape2 = styled(Shape)`
  width: 300px;
  height: 300px;
  bottom: 20%;
  left: 10%;
  background: rgba(26, 41, 128, 0.05);
`;

const Shape3 = styled(Shape)`
  width: 250px;
  height: 250px;
  top: 40%;
  left: 30%;
  background: rgba(38, 208, 206, 0.03);
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
`;

export default App;
